import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import JavascriptTimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import pl from 'javascript-time-ago/locale/pl'
import Dashboard from './dashboard_env/app/App'
import LangProvider from './dashboard_env/context/lang-context'
import LoaderProvider from './dashboard_env/context/loader-context'
import ErrorProvider from './dashboard_env/context/error-context'
import NotificationProvider from './dashboard_env/context/notification-context'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

import 'react-notifications/lib/notifications.css'
import parseCookies from './dashboard_env/util/parseCookies'
import { EndSessionTimerProvider } from './dashboard_env/context/end-session-timer-context'

JavascriptTimeAgo.addLocale(en)
JavascriptTimeAgo.addLocale(pl)
if (!sessionStorage.getItem("isOnline")) sessionStorage.setItem("isOnline", navigator.onLine)


    if(window.location.pathname === "/dashboard/login" && sessionStorage.getItem("isMobile")) {
        sessionStorage.removeItem("isMobile")
    }
parseCookies()

render(
    <BrowserRouter basename={'dashboard'}>
            <LangProvider>
                <LoaderProvider>
                    <ErrorProvider>
                        <NotificationProvider>
                            <EndSessionTimerProvider>
                                <Dashboard />
                            </EndSessionTimerProvider>
                        </NotificationProvider>
                    </ErrorProvider>
                </LoaderProvider>
            </LangProvider>
    </BrowserRouter>,
    document.getElementById('root')
)

serviceWorkerRegistration.register();